const normalizeContentType = (contentType = "") =>
  contentType.split(";")[0].trim().toLowerCase();

export const isImageDocument = (document) =>
  normalizeContentType(document?.contentType).startsWith("image/");

export const isPdfDocument = (document) =>
  normalizeContentType(document?.contentType) === "application/pdf";

export const canPreviewDocument = (document) =>
  Boolean(document?.fileId) &&
  (isImageDocument(document) || isPdfDocument(document));
